<template>
  <div>
    <b-table
      responsive
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      no-local-sorting
      sort-icon-left
    >
      <template
        v-if="listFilters"
        #top-row="data"
      >
        <td
          v-for="(field,key) in data.fields"
          :key="key"
        >
          <list-column-filter
            v-if="field.key !=='action'"
            :name="field.key"
            :label="field.label"
            :filter="listFilters[field.key]"
            :value="filters[field.key]"
            @onFilterChange="( name, value)=> $emit('onFilterChange', name, value)"
          />
          <b-button
            v-else
            block
            variant="success"
            @click="$emit('onFilterButtonClicked')"
          >
            {{ $t("Search") }}
          </b-button>
        </td>
      </template>
      <!-- A custom formatted payment_id column -->
      <template #cell(payment_id)="data">
        <router-link
          :to="{name:'payments-show',params:{id:data.value}}"
          target="_blank"
        >
          {{ $t('Payment') }} {{ data.value }}
        </router-link>
      </template>
      <!-- A custom formatted user column -->
      <template #cell(user)="data">
        <display-user :user="data.value" />
      </template>
      <!-- A custom formatted amount column -->
      <template #cell(amount)="data">
        <display-currency :value="data.value" />
      </template>
      <!-- A custom formatted payment_at column -->
      <template #cell(payment_at)="data">
        <display-date-time :value="data.value" />
      </template>
      <!-- A custom formatted status column -->
      <template #cell(status)="data">
        <display-status
          :value="data.value"
          :text="data.item.display_status"
        />
      </template>
      <!-- A custom formatted confirmed_at column -->
      <template #cell(confirmed_at)="data">
        <display-date-time :value="data.value" />
      </template>
      <!-- A custom formatted action column -->
      <template #cell(action)="data">
        <bank-receipts-attachments-dropdown
          :bank-receipt="data.item"
          size="xs"
        />
        <b-button
          v-if="data.item.note"
          :id="`show-note-${data.item.id}`"
          variant="flat-secondary"
          size="sm"
          class="btn-icon rounded-circle"
        >
          <feather-icon icon="BookIcon" />
          <b-tooltip
            :target="`show-note-${data.item.id}`"
            placement="top"
          >
            {{ data.item.note }}
          </b-tooltip>
        </b-button>
        <b-button
          v-if="data.item.editable"
          variant="flat-success"
          size="sm"
          class="btn-icon rounded-circle"
          @click="editButtonClicked(data.item)"
        >
          <feather-icon icon="Edit2Icon" />
        </b-button>
      </template>
    </b-table>
    <div
      v-if="!items.length"
      class="d-flex justify-content-center align-items-center"
    >
      <h6 class="font-weight-bolder mb-0">
        {{ $t("There are no bank receipts to display") }}
      </h6>
    </div>
    <bank-receipts-edit-modal
      :form="editForm"
      :additional-data="additionalData"
      @onHideModal="resetEditForm"
      @onItemCreated="createdItem"
      @onItemUpdated="updatedItem"
    />
  </div>
</template>

<script>

import { ListTable } from '../../../common/mixins/list'
import BankReceiptsEditModal from '../edit/BankReceiptsEditModal'
import BankReceiptsAttachmentsDropdown from './BankReceiptsAttachmentsDropdown'

export default {
  name: 'BankReceiptsList',
  components: { BankReceiptsAttachmentsDropdown, BankReceiptsEditModal },
  mixins: [ListTable],
  data() {
    return {
      routeName: 'bank-receipts',
    }
  },
  created() {
    this.resetEditForm()
  },
  methods: {
    resetEditForm() {
      setTimeout(() => {
        this.editForm = {}
        if (this.$route.name === 'payments-show') {
          this.editForm.payment_id = this.$route.params.id
        }
      }, 500)
    },
  },
}
</script>

<style scoped>

</style>
